// Named-modal registry + controller. Preserves the vue-js-modal API surface
// (`$modal.show(name, params)`, `$modal.hide(name)`) on top of vue-final-modal.
//
// 185+ call sites across the codebase use the show/hide pattern and ~48 modal
// definitions use `<modal name="x">` — wrapping behind this controller means
// none of those sites need to change.

import { reactive } from 'vue'

// Keyed by modal name. Each entry: { visible: boolean, params: object }.
const registry = reactive({})

function ensure(name) {
  if (!registry[name]) {
    registry[name] = { visible: false, params: null }
  }
  return registry[name]
}

export function getModalEntry(name) {
  return ensure(name)
}

export const modalController = {
  show(name, params = {}) {
    const entry = ensure(name)
    entry.params = params
    entry.visible = true
  },
  hide(name) {
    if (registry[name]) {
      registry[name].visible = false
    }
  },
}
